import { render, staticRenderFns } from "./newsForm.vue?vue&type=template&id=5f8a7144&scoped=true&"
import script from "./newsForm.vue?vue&type=script&lang=js&"
export * from "./newsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a7144",
  null
  
)

export default component.exports